import { inject } from '@angular/core';
import type { CanActivateFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { catchError, map, of, switchMap, take } from 'rxjs';

import { ConsentActions } from '../../pages/menu/consent-modal/redux/consent.actions';
import { ConsentRestService } from '../../pages/menu/services/consent.rest.service';
import { GeneralSelectors } from '../redux/general/general.reducer';

export const consentGuard: CanActivateFn = () => {
  const store = inject(Store);
  const consentRestService = inject(ConsentRestService);

  return store.select(GeneralSelectors.activeAppLanguage).pipe(
    take(1),
    switchMap(language =>
      consentRestService.loadMissingConsents$(language).pipe(
        map(missing => {
          if (missing.some(c => !c.optional)) {
            store.dispatch(ConsentActions.missingConsentsRequested({ language }));
          }
          return true;
        }),
        catchError(() => of(true))
      )
    )
  );
};
